import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Text,
} from '@chakra-ui/react';
import { useToasts } from 'react-toast-notifications';
import { deleteTag } from '../api/tag';
import { getApiErrorMessage } from '../utils/apiError';

const DeleteTagModalComponent = ({ isOpen, onClose, tag, onSuccess }) => {
  // onSuccess prop'u eklendi
  const { addToast } = useToasts();

  const handleDelete = async () => {
    try {
      await deleteTag(tag.registerId);
      addToast('Tag deleted successfully', { appearance: 'success' });
      onSuccess(); // Başarı durumunda onSuccess fonksiyonunu çağır
      onClose();
    } catch (error) {
      console.error('Error deleting tag:', error);
      addToast(getApiErrorMessage(error, 'Error deleting tag'), {
        appearance: 'error',
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete The Tag Settings?</ModalHeader>
        <ModalBody>
          <Text>This process cannot be undone.</Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" onClick={handleDelete}>
            Delete
          </Button>
          <Button colorScheme="blue" onClick={onClose} ml={3}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteTagModalComponent;
